export const commonHelpers = {
  createScriptTag,
  createScriptIframeTag,
  createDownloadTag,
  isiOS,
  checkBrowser,
  isPromise,
  getHashCode,
  isEmpty
};


function createScriptTag(scriptUrl, onload, onerror) {
  const script = document.createElement("script");
  
  if(typeof onload === 'function') script.onload = onload;
  if(typeof onerror === 'function') script.onerror = onerror;
  
  script.type = "text/javascript";
  script.async = true;
  script.src = scriptUrl;

  document.head.appendChild(script);
  return script;
}

// this function will create an iframe and append the script tag to the iframe.
// the id is used to identify the iframe; if the iframe with the same id already exists, it will be removed and recreated.
// if the id is not provided, a random id will be generated. 
function createScriptIframeTag(id, scriptUrl, onload, onerror) {

  if(!id) { // generate random id if not provided
    id = 'sc_iframe_' + Math.random().toString(36).substring(2, 9);
  };

  // Remove any previous iframe
  const existing = document.getElementById(id);
  if (existing) existing.remove();

  const iframe = document.createElement('iframe');
  iframe.id = id;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  const script = iframe.contentDocument.createElement('script');
  if(typeof onload === 'function') script.onload = onload;
  if(typeof onerror === 'function') script.onerror = onerror;
  script.src = scriptUrl;
  iframe.contentDocument.body.appendChild(script);

  return { iframe, script };
}

function createDownloadTag(blob, filename = 'download.pdf', contentType = 'application/pdf') {

  // const win =  window.open(URL.createObjectURL(blob));
  // if (!win || win.closed || typeof win.closed === 'undefined') {
    //POPUP BLOCKED
    const url = window.URL.createObjectURL(new Blob([blob], { type: contentType}));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);

    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
  //}
}

function isiOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

function checkBrowser() { 
          
  // Get the user-agent string 
  const userAgentString =  
      navigator.userAgent; 

  // Detect Chrome 
  let chromeAgent =  
      userAgentString.indexOf("Chrome") > -1 || userAgentString.indexOf("CriOS") > -1; 

  // Detect Internet Explorer 
  const IExplorerAgent =  
      userAgentString.indexOf("MSIE") > -1 ||  
      userAgentString.indexOf("rv:") > -1; 

  // Detect Firefox 
  const firefoxAgent =  
      userAgentString.indexOf("Firefox") > -1 || userAgentString.indexOf("FxiOS") > -1; 

  // Detect Safari 
  let safariAgent =  
      userAgentString.indexOf("Safari") > -1; 
        
  // Discard Safari since it also matches Chrome 
  if ((chromeAgent || firefoxAgent) && (safariAgent))  
      safariAgent = false; 

  // Detect Opera 
  const operaAgent =  
      userAgentString.indexOf("OP") > -1; 
        
  // Discard Chrome since it also matches Opera      
  if ((chromeAgent) && (operaAgent))  
      chromeAgent = false; 

  return {
    safariAgent,
    chromeAgent,
    IExplorerAgent,
    operaAgent,
    firefoxAgent
  }
}

function isPromise(foo) {
  return foo && typeof foo.then === 'function';
}

function getHashCode(...values) {
  const value = values.map(v => typeof(v) === 'string' ? v : JSON.stringify(v)).join('')

  const arr = value.split('');
  return arr.reduce(
    (hashCode, currentVal) =>
      (hashCode = currentVal.charCodeAt(0) + (hashCode << 6) + (hashCode << 16) - hashCode),
    0
  )
}

function isEmpty(value) {
  // check if the value of string is n
  if(!value) {
    return true;
  }

  if (typeof value === 'string') {
    return value.trim().length === 0;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }
  return false;
}